import { render } from "./ViewPayrollEarnings.vue?vue&type=template&id=51162e65"
import script from "./ViewPayrollEarnings.vue?vue&type=script&lang=js"
export * from "./ViewPayrollEarnings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__